import React, { useEffect, useState } from 'react'
import { userAvatarUrl, userInitials } from '../utils/userProfile'

interface UserAvatarProps {
  name?: string | null
  avatar?: string | null
  size?: number
}

const UserAvatar: React.FC<UserAvatarProps> = ({ name, avatar, size = 64 }) => {
  const [failed, setFailed] = useState(false)
  const uri = userAvatarUrl(avatar)

  useEffect(() => {
    setFailed(false)
  }, [uri])

  const showPhoto = !!uri && !failed

  return (
    <div
      className="rounded-full overflow-hidden bg-primary/15 flex items-center justify-center border border-border shrink-0"
      style={{ width: size, height: size }}
    >
      {showPhoto ? (
        <img
          src={uri}
          alt=""
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <span className="font-extrabold text-primary" style={{ fontSize: Math.round(size * 0.36) }}>
          {userInitials(name)}
        </span>
      )}
    </div>
  )
}

export default UserAvatar
